export default __webpack_public_path__ + "static/media/LightBulb.9715a133.png";